import { LeftSideBar, Navigation, UserMenuTopBar } from 'components/core-v2'
import { useResetTradeBuilder } from 'state/store'

import { DraftTradesSmart } from './pages/smart'

export const DraftTrades = () => {
  useResetTradeBuilder()
  return (
    <LeftSideBar
      leftElement={<Navigation />}
      mainElement={<DraftTradesSmart />}
      topBarElement={<UserMenuTopBar />}
    />
  )
}
